
export const linksList = {
  cablesTermsLink: 'https://www.cables.finance/terms-of-use',
}